import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import { IGetPostRequest, IUseAddMutation, IAddFn, ISafetyCase, ISafetyCaseAddUpsert } from '../../interfaces'

const getCreateSafetyCaseMutationRequest: IGetPostRequest = () => ({
  method: 'post',
  url: `${config.baseUrl}/sms/SafetyCases`,
})

const useCreateSafetyCaseMutation: IUseAddMutation<ISafetyCase, ISafetyCaseAddUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getCreateSafetyCaseMutationRequest(params), [params])

  const createSafetyCase: IAddFn<ISafetyCaseAddUpsert, ISafetyCase> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCase, Error, ISafetyCaseAddUpsert>({
    mutationFn: createSafetyCase,
    ...options,
  })

  return response
}

export default useCreateSafetyCaseMutation
